import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { AbstractCirculationsService } from "src/app/interfaces";
import { Notification } from "src/app/notifications/notification";
import { NotificationActions } from "src/app/notifications/state/actions";
import { StepAPIActions } from "./actions";

@Injectable()
export class StepEffects {
  constructor(
    private actions$: Actions,
    private service: AbstractCirculationsService
  ) {}

  loadStepsForCirculation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StepAPIActions.loadStepsForCirculation),
      switchMap((action) =>
        this.service.GetSteps(action.id).pipe(
          map((steps) =>
            StepAPIActions.loadStepsForCirculationSuccess({ steps })
          ),
          catchError((error) =>
            of(StepAPIActions.loadStepsForCirculationFailure({ error }))
          )
        )
      )
    );
  });

  loadStepsForCirculationFailure$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StepAPIActions.loadStepsForCirculationFailure),
      map((x) => {
        const notification = {
          content: "loadStepsForCirculationFailure_message",
          level: "error"
        } as Notification;

        if (x.error.status === 404) {
          notification.content = "step.load.not_found";
        } else if (x.error.status === 403) {
          notification.content = "step.load.not_allowed";
        }

        return NotificationActions.showNotification({ notification });
      })
    );
  });
}
